import EventBus from '../../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import '../../../../shared/js/utilities/loading-animation'

//Button click
jQuery(document).on('click', '.training-bookmarks .bookmark', (event) => {
    
    const
        clicked = jQuery(event.currentTarget),
        url = clicked.closest('.training-bookmarks').data('bookmark-url').replace('-1', clicked.data('slug')),
        parent = clicked.parent().parent()
        
    //Show loading animation on button
    EventBus.publish('loading.start', parent)
    
    //Post request to server
    jQuery.post(url, (response) => {
        EventBus.publish('training.bookmark.update', {
            bookmarked: response.bookmarked,
            element: clicked
        })
    }).always(() => {
        EventBus.publish('loading.stop', parent)
    })
    
})

//Update bookmark button
EventBus.subscribe('training.bookmark.update', ({bookmarked, element}) => {
    if (bookmarked) {
        element.children('i').removeClass('icon-bookmark-empty').addClass('icon-bookmark').attr('title', 'Bookmarked')
    }
    else {
        element.children('i').removeClass('icon-bookmark').addClass('icon-bookmark-empty').attr('title', 'Bookmark')
    }
})